const FullBanner = (data) => {
    return (
        <div className="fullBanner" style={{height:`${data.height}px`}}>
            {data.children}
        </div>
    );
}

export {FullBanner};